import { ref } from "vue";

const breakdown_output = ref({});

export {
    breakdown_output
}